import http from "../config/axiosConfig/http-common";
import { GetServerVersion, SetServerVersion } from "../config/localstorageConfig/localstorage";
import ServiceBase from "./service.base";

class ConfigService extends ServiceBase {

    getServerVerion() {
        return http.get("/Config/Version");
    }

    async setCacheServerVersion() {
        const serverVersion = GetServerVersion();
        if (serverVersion) {
            return;
        }

        try {
            const response = await this.getServerVerion();
            SetServerVersion(response.data.value);
        } catch (e) {
            SetServerVersion("");
            console.error("Erro ao carregar server version:", e);
            throw e;
        }
    }
}

export default new ConfigService();